/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable import/no-unresolved */
/* eslint-disable no-console */
/* eslint-disable import/no-extraneous-dependencies */
import {useEffect, useState} from 'react';
import ReactPaginate from 'react-paginate';
// eslint-disable-next-line import/named
import {confirmAlert} from 'react-confirm-alert';

import {
	useGetReMapSetsQuery,
	useGetReMapSetsSizeQuery,
	useDeleteReMapMutation,
	useLazyGetReMapSetDownloadQuery,
	useLazyGetReMapSetViewQuery,
} from 'services';
import type {ReMapBD} from 'interfaces';
import ModalUploadFile from './components/ModalUploadFile';

import 'react-confirm-alert/src/react-confirm-alert.css';
import ModalCSVView from './components/ModalCSVView';
import {useAppSelector} from 'store/hooks';
import {hasExactRole} from 'utils';

const LIMIT = Number(process.env.REACT_APP_PAGINATE_LIMIT || 10);

type TData = {
	selected: number;
};

const MappingsPolicy = () => {
	const {roles} = useAppSelector(state => state.user);
	const isReadOnly = hasExactRole(roles, 'policy_engine_read_only');

	const [pageCount, setPageCount] = useState(0);
	const [openModalUpload, setOpenModalUpload] = useState(false);
	const [openModalView, setOpenModalView] = useState(false);
	const [page, setPage] = useState<number>(0);
	const [csvData, setCsvData] = useState('');
	const [isEditTitle, setIsEditTitle] = useState<string | undefined>('');

	const {data: totalReMap = 0, refetch: refetchTotalReMap} =
		useGetReMapSetsSizeQuery(undefined);
	const {data: getReMapData = [], refetch: refetchGetReMapData} =
		useGetReMapSetsQuery(page);
	const [getReMapDownload] = useLazyGetReMapSetDownloadQuery();
	const [getReMapView] = useLazyGetReMapSetViewQuery();

	const refetchAll = () => {
		void refetchTotalReMap();
		void refetchGetReMapData();
	};

	const [deleteReMap] = useDeleteReMapMutation();

	/* Setting the pageCount to the ceiling of the totalReMap divided by the limit. */
	useEffect(() => setPageCount(Math.ceil(totalReMap / LIMIT)), [totalReMap]);

	/**
	 * It sets the page to the number passed in.
	 * @param {number} param - number - This is the parameter that is passed to the function. In this
	 * case, it's a number.
	 */
	const handlePage = (param: number) => setPage(param);

	/**
	 * It takes an object with a property called selected, which is a number, and then it sets the
	 * currentPage to that number plus one, and then it calls the handleGetData function with the
	 * currentPage as an argument, and then it sets the items to the result of that function, and then it
	 * sets the pageCount to the ceiling of the totalReMap divided by the limit
	 * @param {TData}  - TData - this is the type of the object that is passed to the function.
	 */
	const handlePageClick = ({selected}: TData) => {
		const currentPage = selected;

		handlePage(currentPage);
		setPageCount(Math.ceil(totalReMap / LIMIT));
	};

	/**
	 * It returns an object with the properties that the modal component needs to render
	 * @param {String} name - ReMap - The item that is being passed to the modal.
	 */
	const optionsRemoveModal = (name: string) => ({
		title: 'Do you really want to remove this mapping transformation?',
		message: 'This action can not be undone.',
		buttons: [
			{
				label: 'Yes',
				onClick: () => {
					void deleteReMap(name);
				},
			},
			{
				label: 'No',
			},
		],
		closeOnEscape: true,
		closeOnClickOutside: true,
		keyCodeForClose: [8, 32],
		overlayClassName: 'overlay-custom-class-name',
	});

	/**
	 * A function that takes in a ReMap object and returns a function that calls the confirmAlert
	 * function with the optionsRemoveModal function.
	 * @param {String} name - ReMap - this is the item that is being passed to the function.
	 */
	const handleRemove = (name: string) => confirmAlert(optionsRemoveModal(name));

	/**
	 * This function toggles the state of a modal window.
	 */
	const handleModalUpload = (title?: string) => {
		setIsEditTitle(title);
		setOpenModalUpload(prev => !prev);
	};

	const handleModalView = () => setOpenModalView(prev => !prev);

	const handleDownload = async (name: string) => {
		try {
			await getReMapDownload(name);
		} catch (error) {
			console.log(error);
		}
	};

	return (
		<div className="card-tasks card h-100" data-testid="modal-csv-view">
			<div className="card-header">
				<i className="bi bi-body-text mr-3 float-left bi-2" />
				<h2 className="card-title">Mappings for Transformations</h2>
				<p className="card-category">
					Maps of transformations stored in the PCRF
				</p>
			</div>
			<div className="card-body pt-0 mt-n4">
				<div
					className={`d-flex flex-row-reverse mb-1 ${
						isReadOnly ? 'pt-4' : ''
					}`}>
					{!isReadOnly && (
						<button
							id="modalUploadFile"
							className="border-0 bg-transparent d-inline"
							data-toggle="modal"
							data-target="#modalUploadFile"
							onClick={() => handleModalUpload()}>
							<i
								className="bi-1 bi-upload"
								title=""
								data-toggle="tooltip"
								data-original-title="Upload"
							/>
						</button>
					)}
				</div>
				<div className="card-body table-responsive p-0">
					<table className="table table-striped table-sm table-head-fixed text-nowrap">
						<thead>
							<tr>
								<th className="col">Name</th>
								<th>Actions</th>
							</tr>
						</thead>
						<tbody>
							{getReMapData.length ? (
								getReMapData.map((item: ReMapBD, key: number) => (
									<tr key={key}>
										<td>{item.nameRemap}</td>
										<td>
											{/* <button
												className="border-0 bg-transparent d-inline"
												onClick={() => handleModalUpload(item.nameRemap)}>
												<i
													className="bi-1 bi-upload"
													title=""
													data-toggle="tooltip"
													data-original-title="Upload"
												/>
											</button> */}
											<button
												className="border-0 bg-transparent d-inline"
												onClick={() => handleDownload(item.nameRemap)}>
												<i
													className="bi-1 bi-download"
													title=""
													data-toggle="tooltip"
													data-original-title="Download"
												/>
											</button>
											<button
												onClick={async () => {
													const {
														error: {data},
													}: any = await getReMapView(item.nameRemap);
													setCsvData(data);
													handleModalView();
												}}
												className="border-0 bg-transparent d-inline">
												<i
													className="bi-1 bi-eye"
													title=""
													data-toggle="tooltip"
													data-original-title="CSV"
												/>
											</button>
											{!isReadOnly && (
												<button
													className="border-0 bg-transparent d-inline"
													onClick={() => handleRemove(item.nameRemap)}>
													<i
														className="bi-1 bi-trash-fill text-danger"
														title=""
														data-toggle="tooltip"
														data-original-title="Delete"
													/>
												</button>
											)}
										</td>
									</tr>
								))
							) : (
								<tr>
									<td colSpan={2} className="text-center">
										No Mappings for Transformation created
									</td>
								</tr>
							)}
						</tbody>
					</table>
				</div>
			</div>

			<ReactPaginate
				previousLabel="Previous"
				nextLabel="Next"
				breakLabel="..."
				pageCount={pageCount}
				marginPagesDisplayed={2}
				pageRangeDisplayed={2}
				onPageChange={handlePageClick as never}
				containerClassName="pagination justify-content-center"
				pageClassName="page-item"
				pageLinkClassName="page-link"
				previousClassName="page-item"
				previousLinkClassName="page-link"
				nextClassName="page-item"
				nextLinkClassName="page-link"
				breakClassName="page-item"
				breakLinkClassName="page-link"
				activeClassName="active"
			/>

			<ModalUploadFile
				type="ReMap"
				open={openModalUpload}
				onClose={handleModalUpload}
				refetch={refetchAll}
				isEditTitle={isEditTitle}
			/>

			<ModalCSVView
				open={openModalView}
				onClose={handleModalView}
				data={csvData}
			/>
		</div>
	);
};

export default MappingsPolicy;
